import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { UserService } from '../services/user.service';
import { AnalyticsService } from '../services/analytics/analytics.service';

@Injectable()
export class SavedSearchUnsubscribeResolver implements Resolve<string> {
  constructor(
      private userService: UserService,
      private analyticsService: AnalyticsService
  ) { }

    resolve(route: ActivatedRouteSnapshot): string {
      if (route.queryParamMap.keys.includes('key')) {
        return route.queryParamMap.get('key');
      } else {
          return null;
      }
  }
}
